<template>
  <div class="print-d" style="margin: auto; min-height: 100mm" v-loading="loading">
    <div class="main" v-for="(item, index) in list" :key="index">
      <div class="title">{{ docName }}</div>
      <div class="form">
        <div class="form-item"><span class="label">单据日期：</span>{{ $commonJs.toDateString(data.DocDate) }}</div>
        <div class="form-item" style="width: 40%"><span class="label">工单号：</span>{{ data.WorkDocNo }}</div>
        <div class="form-item"><span class="label">生产类型：</span> {{ data.ProductionType === 0 ? '自产' : '委外' }}</div>
        <div class="form-item"><span class="label">完工日期：</span>{{ $commonJs.toDateString(data.EndTime) }}</div>
        <div class="form-item" style="width: 40%"><span class="label">所属产成品：</span> {{ data.ProductName }}</div>
        <div class="form-item"><span class="label">部门/单位：</span> {{ data.ProductionType ? data.FullName : data.DpName }}</div>
        <div class="form-item"><span class="label">备注：</span> {{ data.ClothRemark ? data.ClothRemark : data.Remark }}</div>
        <div class="form-item">
          <span class="label">生产要求：</span>
        </div>
      </div>
      <div class="qrcode">
        <vue-qr :text="data.WorkDocNo" qid="qrid" :size="90" :margin="10"></vue-qr>
      </div>
      <table class="report-table" border="1" v-if="data.ProductModels.length && docName == '注塑工单'">
        <tr>
          <td class="center bold">序号</td>
          <td class="center bold">模具编号</td>
          <td class="center bold">模具名称</td>
          <td class="center bold">模数</td>
          <td class="center bold">单重</td>
          <td class="center bold">总重</td>
          <td class="center bold">备注</td>
        </tr>
        <tr>
          <td class="center">1</td>
          <td class="center">{{ data.ProductModels[0].MouldNo }}</td>
          <td class="center">{{ data.ProductModels[0].MouldBomNo }}</td>
          <td class="center">{{ data.ProductModels[0].Quantity }}</td>
          <td class="center">{{ data.ProductModels[0].PerNetWeight }}</td>
          <td class="center">{{ count(data.ProductModels[0]) }}</td>
          <td class="center">{{ data.ProductModels[0].Remark }}</td>
        </tr>
      </table>
      <table class="report-table" border="1" v-else-if="data.ProductModels.length">
        <tr>
          <td class="center bold">产品编码</td>
          <td class="center bold">产品名称</td>
          <td class="center bold">规格型号</td>
          <td class="center bold">颜色</td>
          <td class="center bold">数量</td>
          <td class="center bold">预开工日</td>
          <td class="center bold">预完工日</td>
          <td class="center bold">应入库数</td>
          <td class="center bold">备注</td>
          <td class="center bold">设计图</td>
        </tr>
        <tr>
          <td class="center">{{ data.ProductModels[0].ProductNo }}</td>
          <td class="center">{{ data.ProductModels[0].ProductName }}</td>
          <td class="center">{{ data.ProductModels[0].ProductSpec }}</td>
          <td class="center">{{ data.ProductModels[0].ColorName }}</td>
          <td class="center">{{ data.ProductModels[0].Quantity }}</td>
          <td class="center">{{ $commonJs.toDateString(data.ProductModels[0].StartTime) }}</td>
          <td class="center">{{ $commonJs.toDateString(data.ProductModels[0].EndTime) }}</td>
          <td class="center">{{ data.ProductModels[0].AnswerQuantity }}</td>
          <td class="center">{{ data.ProductModels[0].Remark }}</td>
          <td class="center">
            <div class="demo-image" v-if="imgs.length">
              <div class="block" v-for="(item, index) in imgs" :key="'a' + index">
                <el-image style="width: 100px; height: 100px" :src="item" fit="fill" :preview-src-list="imgs"></el-image>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="center bold">合计</td>
          <td class="center bold"></td>
          <td class="center bold"></td>
          <td class="center bold"></td>
          <td class="center bold">{{ data.ProductModels[0].Quantity }}</td>
          <td class="center bold"></td>
          <td class="center bold"></td>
          <td class="center bold"></td>
          <td class="center bold"></td>
          <td class="center bold"></td>
        </tr>
      </table>
      <table class="report-table" border="1" v-if="data.ProductModels.length && data.ProductModels[0].BomRubbers && data.ProductModels[0].BomRubbers.length">
        <tr>
          <td class="center bold">序号</td>
          <td class="center bold">胶件编码</td>
          <td class="center bold">胶件名称</td>
          <td class="center bold">胶件颜色</td>
          <td class="center bold">属性</td>
          <td class="center bold">数量</td>
          <td class="center bold">备注</td>
        </tr>
        <tr v-for="(item, index) in data.ProductModels[0].BomRubbers" :key="item.ProductId">
          <td class="center">{{ index + 1 }}</td>
          <td class="center">{{ item.ProductNo }}</td>
          <td class="center">{{ item.ProductName }}</td>
          <td class="center">{{ item.ColorName }}</td>
          <td class="center">注塑</td>
          <td class="center">{{ item.Quantity }}</td>
          <td class="center">{{ item.Remarks }}</td>
        </tr>
      </table>
      <!-- <div v-if="data.MaterialModels.length">材料明细</div> -->
      <div v-if="item.cl.length">材料明细</div>
      <!-- <table class="report-table" border="1" v-if="data.MaterialModels.length"> -->
      <table class="report-table" border="1" v-if="item.cl.length">
        <tr>
          <td class="center bold">序号</td>
          <td class="center bold">子件编码</td>
          <td class="center bold">子件名称</td>
          <td class="center bold">子件规格</td>
          <td class="center bold">颜色</td>
          <td class="center bold">单位</td>
          <td class="center bold">应领数</td>
          <td class="center bold">实领数</td>
          <td class="center bold">退数</td>
          <td class="center bold">备注</td>
        </tr>
        <!-- <tr v-for="(item, index) in data.MaterialModels" :key="item.ProductId"> -->
        <tr v-for="(item, index) in item.cl" :key="item.ProductId">
          <td class="center">{{ index + 1 }}</td>
          <td class="center">{{ item.ProductNo }}</td>
          <td class="center">{{ item.ProductName }}</td>
          <td class="center">{{ item.ProductSpec }}</td>
          <td class="center">{{ item.ColorName }}</td>
          <td class="center">{{ item.UnitName }}</td>
          <td class="center">{{ item.Quantity || 0 }}</td>
          <td class="center"></td>
          <td class="center"></td>
          <td class="center">{{ item.Remarks }}</td>
        </tr>
      </table>
      <div class="form2">
        <div class="form-item">
          <span class="label">制单人：{{ data.AddUserName }}</span>
        </div>
        <div class="form-item" style="width: 66.66%">
          <span class="label">签收人：</span>
        </div>
      </div>
    </div>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print" :disabled="loading">打印</el-button>
    </div>
  </div>
</template>
<script>
const loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
const NeedUnit = localStorage.getItem('NeedUnit')
const NeedRate = localStorage.getItem('NeedRate')
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  beforeMount() {
    document.title = localStorage.getItem('webTitle')
    this.loading = true
    var id = this.$route.query.id
    var name = this.$route.query.name
    switch (this.$route.query.t) {
      case '0':
        this.docName = '注塑工单'
        break
      case '1':
        this.docName = '特殊工艺工单'
        break
      case '2':
        this.docName = '配件工单'
        break
      case '3':
        this.docName = '装配工单'
        break
      case '4':
        this.docName = '组合工单'
        break
    }
    if (name != null) {
      this.docName = name + '工单'
    }
    this.api.info(id).then(res => {
      this.loading = false
      if (res.Code == 0) {
        this.data = res.Data
        var imgs = []
        console.log(res.Data);
        if (res.Data.ProductModels[0].PdImgs) {
          res.Data.ProductModels[0].PdImgs.forEach(item => {
            imgs.push('/api' + item.ImgUrl)
          })
          this.imgs=imgs;
        }

        var total = res.Data.MaterialModels.length
        var mm = res.Data.MaterialModels
        // res.Data.Stage = 0;
        var num = res.Data.Stage == 0 ? 11 : 20
        if (total > num) {
          this.list = []
          var t = Math.ceil(total / num)
          for (let i = 0; i < t; i++) {
            if (i < t - 1) this.list.push({ cl: mm.slice(i * num, i * num + num) })
            else this.list.push({ cl: mm.slice(i * num) })
          }
        } else {
          this.list = [{ cl: mm }]
        }
        console.log('this.list', this.list)
      } else this.$message.error(res.Msg)
    })
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      data: {},
      list: [],
      loginInfo,
      NeedUnit,
      NeedRate,
      docName: '',
      loading: false,
      imgs: []
    }
  },
  methods: {
    total1(arr) {
      var total = 0
      arr.forEach(e => {
        total += Math.floor(e.Quantity * 100)
      })
      return total / 100
    },
    total2(arr) {
      var total = 0
      arr.forEach(e => {
        total += Math.floor(e.Quantity * e.Loss * 100)
      })
      return total / 100
    },
    count(row) {
      return Math.floor(((Number(row.PerNetWeight) * Number(row.Quantity)) / Number(NeedRate)) * 100) / 100
    },
    print() {
      window.print()
    }
  }
}
</script>
<style lang="scss" scoped>
.demo-image {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.block {
  margin: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
}
.print-d {
  width: 297mm;
  padding: 10px 0;
  overflow: visible;
}
.handle-button {
  position: fixed;
  top: 10px;
  right: 40px;
}
.main {
  border: 1px solid #000;
  padding: 10px;
  margin-bottom: 20px;
  .title {
    width: 100%;
    margin: 0px 0 10px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }
  .form {
    width: 90%;
    display: inline-block;
    .form-item {
      width: 30%;
      display: inline-block;
      margin-bottom: 5px;
      .label {
        font-weight: bold;
      }
    }
  }
  .top-form {
    margin-right: 0;
    width: 90%;
    .form-item2 {
      width: 33.33%;
    }
  }
  .qrcode {
    width: 10%;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    margin-top: -20px;
    margin-left: -10px;
    img {
      transform: translateX(-5px);
    }
  }
  .form2 {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .form-item {
      width: 33.33%;
      margin-bottom: 5px;
      .label {
        font-weight: bold;
      }
    }
  }
}
.img {
  width: 100%;
  height: 105mm;
  text-align: center;
  margin-top: 15px;
}
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
  margin-bottom: 15px;
  td {
    padding: 3px 4px;
  }
  .right {
    text-align: right;
  }
  .only-print {
    display: none;
  }
}
.red {
  color: #f11;
}
.bold {
  font-weight: bold;
}
.center {
  text-align: center;
}
@media print {
  .print-d {
    width: 99%;
    padding: 0 !important;
  }
  .no-print {
    display: none;
  }
  .only-print {
    display: block !important;
  }
  .main {
    padding: 0 !important;
    margin-bottom: 0 !important;
    page-break-after: always;
    border: none !important;
  }
}
</style>